const registry = {};

export const registerOfflineAction = (name, thunkCreator) => {
    registry[name] = thunkCreator;
};

export const getOfflineAction = (name) => registry[name];
